import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { filter, map, tap, withLatestFrom } from 'rxjs/operators';
import { AlertService } from 'src/app/services/alert.service';
import { LoadingOverlayService } from 'src/app/services/loading-overlay.service';
import { AppState } from '../reducers';
import * as clientActions from './client.actions';
import { invalidVersionAlertDisplayInitiated } from './client.selectors';

@Injectable()
export class ClientEffects {

	constructor(
		private actions$: Actions,
		private store: Store<AppState>,
		private alertService: AlertService,
		private loadingOverlayService: LoadingOverlayService) {
	}

	showInvalidVersionAlertRequested$ = createEffect(() =>
		this.actions$.pipe(
			ofType(clientActions.showInvalidVersionAlertRequested),
			withLatestFrom(this.store.pipe(select(invalidVersionAlertDisplayInitiated))),
			filter(([, invalidVersionAlertDisplayInitiated]) => !invalidVersionAlertDisplayInitiated),
			map(([payload]) => clientActions.showInvalidVersionAlertInitiated({ requiredVersion: payload.requiredVersion }))
		)
	);

	showInvalidVersionAlertInitiated$ = createEffect(() =>
		this.actions$.pipe(
			ofType(clientActions.showInvalidVersionAlertInitiated),
			tap(payload => {
				this.alertService.displayBlockingAlert(
					'Version update',
					`Version '${payload.requiredVersion}' is available. Please reload the app.`,
					'Reload',
					() => {
						window.location.reload();
						return true;
					}
				);
				this.loadingOverlayService.waitThenRemoveAllOverlays();
			})
		),
		{ dispatch: false }
	);
}